import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FuseAlertComponent } from '@fuse/components/alert';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-login-existing',
  standalone: true,
  imports: [NgIf, NgxSkeletonLoaderModule, FuseAlertComponent, ReactiveFormsModule, MatIconModule, FormsModule, MatInputModule],
  templateUrl: './login-existing.component.html',
  styleUrl: './login-existing.component.scss'
})
export class LoginExistingComponent {

  @Input() userName: string;
  @Input() leadNumber: string

  @Output() passwordValue = new EventEmitter()

  // @Output() passwordValue = new EventEmitter();

  public loading: boolean = true;
  public showAlert: boolean = false;

  public passwordIsValid: boolean;

  public password: string;

  ngOnChanges() {
    if (this.userName) {
      this.loading = false;
    }
  }

  public onPasswordChange(val: any)  {
    this.password = val.target.value;
    this.passwordValue.emit({password: this.password});
  }

}
